<template>


  <div id="page-user-list">
    <vx-card title="เลือกวันที่">
      <flat-pickr v-model="date" />
      <br>
      <br>
          <vs-button color="primary" @click="selectdate(currentWebsite)">ค้นหาในเว็บ {{ currentWebsite.label }}</vs-button>
          <vs-button class="ml-2" color="success" @click="selectdate({ label: 'เว็บไซต์ทั้งหมด', value: 'all' })">ค้นหาทุกเว็บไซต์</vs-button>
        </vx-card>
        <br>
    <div class="vx-card p-6">
      <div class="vx-card__header">
        <div class="vx-card__title">
        </div>
      </div>
      <div class="flex flex-wrap items-center">

        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <!-- <div class="vx-card__title">
            <h4>เลือกวันที่</h4>
            <br>
          </div>


          <flat-pickr v-model="date" />
          <p class="mt-4">Selected Date: {{ date }}</p> -->
   <br>
    <div>
      <vx-card >
        <vs-prompt title="Export To Excel" class="export-options" @cancle="clearFields" @accept="exportToExcel"
            accept-text="Export" @close="clearFields" :active.sync="activePrompt">
            <vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
            <v-select v-model="selectedFormat" :options="formats" class="my-4" />
            <div class="flex">
              <span class="mr-4">Cell Auto Width:</span>
              <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
            </div>
          </vs-prompt>

    <vs-table stripe  max-items="20" pagination :data="memberData" search>

      <template v-if="webname == 'SOLO'" slot="header">
                <vs-button :disabled="$store.state.AppActiveUser.permissions.report.action ? false : true"
                  @click="activePrompt = true">Export</vs-button>

              </template>
    <template slot="thead">
          <vs-th>Datetime</vs-th>
          <vs-th>ยูสเซอร์เนม</vs-th>
          <vs-th>ชื่อ-นามสกุล</vs-th>
          <vs-th>ประเภท</vs-th>
          <vs-th>ก่อนรับ</vs-th>
          <!-- <vs-th>Username</vs-th> -->
          <!-- <vs-th>Password</vs-th> -->
          <vs-th>เครดิตที่ได้รับ</vs-th>
          <vs-th>หลังรับ</vs-th>
          <vs-th>Info</vs-th>
          <vs-th v-if="webname == 'SOLO'">admin</vs-th>
          <vs-th>from</vs-th>
          <vs-th>admin</vs-th>
    </template>
        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="tr.topup_datetime">
              {{moment(tr.topup_datetime).format('YYYY-MM-DD HH:mm:ss')  }}
            </vs-td>

            <vs-td class="text-danger"><router-link :to="`/member/${data[indextr].topup_username}`">{{ data[indextr].topup_username}}</router-link></vs-td>

            <vs-td :data="tr.member_name">
              {{tr.member_name}} {{ tr.member_surname }}
            </vs-td>

            <vs-td :data="tr.topup_type">
              {{tr.topup_type}}
            </vs-td>
            <vs-td :data="tr.topup_before">
              {{currency(tr.topup_before)}}
            </vs-td>
            <vs-td :data="tr.topup_credit">
              {{currency(tr.topup_credit)}}
            </vs-td>
            <vs-td :data="tr.topup_after">
              {{currency(tr.topup_after)}}
            </vs-td>
            <vs-td :data="tr.topup_info">
              {{tr.topup_info}}
            </vs-td>
            <vs-td v-if="webname == 'SOLO'" :data="tr.admin">
              {{tr.admin}}
            </vs-td>
                  <vs-td :data="tr.from_website">
              {{tr.from_website}}
            </vs-td>
            <vs-td v-if="tr.admin" :data="tr.admin">
              {{tr.admin}}
            </vs-td>
            <vs-td v-else>
            AUTO
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>
      </vx-card>
            </div>
        </div>
      </div>
    </div>
  </div>


</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'


import axios from '../../axios'

import moment from 'moment'

export default {
  components: {
    vSelect,
    flatPickr
  },
  data () {
    return {
      webname: process.env.VUE_APP_TITLE,
      date: moment.tz('Asia/Bangkok').format('YYYY-MM-DD'),
      events: ['onChange'],
      config: {},
      searchQuery: '',
      memberData: [],
      components: '',
      bankscb: [],
      activePrompt: false,
      formats: ['xlsx', 'csv', 'txt'],
      cellAutoWidth: true,
      selectedFormat: 'xlsx',
      headerTitle: ['วันเวลาดำเนิการ', 'username', 'ชื่อ', 'นามสกุล', 'ประเภท', 'ยอดเงิน', 'แอดมิน'],
      headerVal: ['topup_datetime', 'topup_username', 'member_name', 'member_surname', 'topup_type', 'topup_amount', 'admin'],
      fileName: ''

    }
  },
  methods: {
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    },
    exportToExcel () {
      import('@/vendor/Export2Excel').then(excel => {
        const list = this.memberData
        const data = this.formatJson(this.headerVal, list)
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })

        this.clearFields()
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j === 'topup_datetime') {
          return moment(v[j]).format('YYYY-MM-DD HH:mm:ss')
        } else {
          return v[j]
        }


      }))
    },
    clearFields () {
      this.filename = ''
      this.cellAutoWidth = true
      this.selectedFormat = 'xlsx'
    },
    currency (amount) {
      if (amount >= 0) {
        if (typeof amount === 'number') {
          amount = String(Math.abs(amount))
        }
        return (amount).replace(/\d(?=(\d{3})+\.)/g, '$&,')
      } else {
        return `${(amount).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
      }

    },
    selectdate (from_website) {
      const { value } = from_website
      // this.$vs.loading()
      axios
        .get(`topup/topupdate/${this.date}/${value}`)
        .then(response => (this.memberData = response.data.data))

      // this.$vs.loading.close()
    }

  },
  watch: {
    currentWebsite (newWebsite, oldWebsite) {
      if (newWebsite.value !== oldWebsite.value) {
        // Put get data function here
        this.selectdate(this.currentWebsite)
      }
    },
    date (newValue) {
      this.date = newValue
      this.selectdate(this.currentWebsite)
    }
  },
  computed: {
    currentWebsite () {
      return this.$store.state.currentWebsite
    }
  },
  async mounted () {
    await this.selectdate(this.currentWebsite)
  }


}

</script>
